module.exports = __webpack_public_path__ + "static/media/howitworks.e86bbaf1.png";